import { render } from "./Quote.vue?vue&type=template&id=19527b08&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"

import "./Quote.vue?vue&type=style&index=0&id=19527b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19527b08"]])

export default __exports__